import { compact } from '@lglp/utils';

import { SortBy } from '../../api/algolia';
import { DocumentType } from '../../types/document';
import { and, attr } from '../algolia/algolia-filters-builder';

export const searchInvestorsPressReleaseDashboard = ({
  hitsPerPage = 500,
  onInvestorsDashboard,
}: searchInvestorsPressReleaseDashboardProps = {}): searchInvestorsPressReleaseDashboardReturnProps => {
  return compact<searchInvestorsPressReleaseDashboardReturnProps>({
    hitsPerPage,
    sortBy: SortBy.PUBLISHED_AT,
    filters: and(
      [
        attr('type', DocumentType.PRESS_RELEASE),
        attr('onFinance', 'true'),
        onInvestorsDashboard && attr('onInvestorsDashboard', 'true'),
      ].filter(Boolean) as string[]
    ),
  });
};

type searchInvestorsPressReleaseDashboardProps = {
  hitsPerPage?: number;
  onInvestorsDashboard?: boolean;
};

type searchInvestorsPressReleaseDashboardReturnProps = {
  hitsPerPage: number;
  sortBy: SortBy;
  filters: string;
};
